export const isSafari =
    navigator.vendor.match(/apple/i) &&
    !navigator.userAgent.match(/crios/i) &&
    !navigator.userAgent.match(/fxios/i) &&
    !navigator.userAgent.match(/Opera|OPT\//);

export const toggleFullScreenOn = async (): Promise<void> => {
    const doc = window.document;
    const docEl = doc.documentElement;

    const requestFullScreen =
        docEl.requestFullscreen ||
        (docEl as any).mozRequestFullScreen ||
        (docEl as any).webkitRequestFullScreen ||
        (docEl as any).msRequestFullscreen;

    try {
        if (!isSafari) {
            await requestFullScreen.call(docEl);
        }
    } catch {}
};

export const toggleFullScreenOff = async (): Promise<void> => {
    const doc = window.document;
    const docEl = doc.documentElement;

    const cancelFullScreen =
        doc.exitFullscreen ||
        (docEl as any).mozCancelFullScreen ||
        (docEl as any).webkitExitFullscreen ||
        (docEl as any).msExitFullscreen;

    if (!isSafari) {
        await cancelFullScreen.call(doc);
    }
};

export const enableKeyBoard = (): void => {
    const doc = window.document;
    const docEl = doc.documentElement;

    docEl.onkeydown = function (e) {
        return true;
    };
};

export const disableKeyBoard = (): void => {
    const doc = window.document;
    const docEl = doc.documentElement;

    docEl.onkeydown = function (e) {
        return false;
    };
};
